var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoPhoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.73 44.73"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 3",
    cx: 22.36,
    cy: 22.36,
    r: 22.36,
    fill: "#273475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.55 27.08l-5.27-2.26a1.12 1.12 0 00-1.32.32L24.62 28a17.48 17.48 0 01-8.34-8.35l2.85-2.33a1.12 1.12 0 00.33-1.32l-2.26-5.28a1.15 1.15 0 00-1.3-.65L11 11.19a1.13 1.13 0 00-.87 1.11A21.84 21.84 0 0032 34.15a1.12 1.12 0 001.1-.87l1.13-4.9a1.15 1.15 0 00-.66-1.3z",
    fill: "#fff"
  }))))));
}

export default SvgCoPhoneinline;